'use strict'

import benefitFormDefinition from './benefitFormDefinition.js';

export default [
  {
    name: "strategy",
    fields: [
      { name: "reasons", height:5 }
    ]
  },
  {
    name: "options",
    fields: [
      { name: "doNothing", height:5 },
      { name: "doMinimal", optional:true, height:5 },
      { name: "doSomething", height:5 }
    ]
  },
  {
    name: "benefits",
    fields: [
      {
        name: "benefits",
        type: "table",
        options: {
          addEntry: {
            formDefinition: benefitFormDefinition
          },
          edit: {
            formDefinition: benefitFormDefinition
          }
        },
        columns: [
          { name: "no", priority:true },
          { name: "title", dragable:true },
          { name: "baseline" },
          { name: "goal" },
          { name: "accountable" },
        ],
        samples: [
          {id: 1, no:"1", benefit:"My benefit", baseline:"The baseline", goal: "My goal", accountable:"me"}
        ]
      }
    ]

  },
  {
    name: "returnOnInvestment",
    fields: [
      { name:"projectPlanSummary", height:5 },
      { name: "investmentAppraisal", height:5 },
      { name: "risks", height: 5 }
    ]
  },
  {
    name: "summary",
    fields: [
      { name: "executiveSummary", height:8 },
    ]
  }
]



// WEBPACK FOOTER //
// ./views/businessCase/formDefinition.js